var module = angular.module('octopusApp.configuration');

module.controller('UsersIndexController', function($scope, busy, octopusRepository, octopusClient) {
  var isLoading = $scope.isLoading = busy.create();
  isLoading.promise(octopusRepository.Alerts.list().then(function(alerts) {
    $scope.alerts = alerts;
  }));
  isLoading.promise(octopusRepository.ServerStatus.getServerStatus().then(function(status) {
    isLoading.promise(octopusRepository.Users.list().then(function (users) {
      $scope.users = users;
      $scope.status = status;

      var root = octopusClient.rootDocument();
      $scope.canInviteUsers = root.AnyAuthenticationProvidersSupportPasswordManagement;
    }));
  }));
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/users/controllers/users_index_controller.js
// module id = 2830871274600692
// module chunks = 1